<template>
    <div>
        <h2 class="container">
            ข้อมูลของ Course 
            {{$route.params.courseCode}}
            Testing: {{date}}
        </h2>
        <select v-model="birthDate" @change="setBirthDate(birthDate)">
            <option :value="null" disabled>DD</option>
            <option v-for="(idea, index) in date" :key="index" :value="index+1">{{ index+1 }}</option>
        </select>

        <select v-model="birthMonth" @change="setBirthMonth(birthMonth)">
            <option :value="null" disabled>MM</option>
            <option v-for="(idea, index) in month" :key="index" :value="index+1">{{ index+1 }}</option>
        </select>

        <select v-model="birthYear" @change="setBirthYear(birthYear)">
            <option :value="null" disabled>YYYY</option>
            <option v-for="(idea, index) in year" :key="index" :value="idea">{{ idea }}</option>
        </select>
        
        <!-- <div v-if="courseData.background">
            <img :src= "courseData.background[0].url " alt= "courseData.bacckground[0].url" width= 100% height= 640px/>
        </div> -->
        <!-- <div v-else>

        </div>
        <p>
            {{courseData}}
        </p> -->
    </div>
</template>

<script>
import Service from '../service/api';
    export default{
        name: 'TestingSingleCourse',
        data() {
            return {
                year:[] ,
                month: 12,
                date: 30,
                birthDate: null,
                birthMonth: null,
                birthYear: null,
                courseData: {},
            }
        },
        methods: {
            setBirthDate: function(value) {
                alert('Date: '+value)
                this.birthDate= value;
            },
            setBirthMonth: function(value) {
                alert('Month: '+value)
                this.birthMonth= value;
            },
            setBirthYear: function(value) {
                alert('Year: '+value)
                this.birthYear= value;
            }
        },
        watch: {
            birthMonth: function(value) {
                let date= new Date().getFullYear();

                if(value === 1 || value=== 3 || value=== 5 || value=== 7 || value=== 8 || value=== 10 || value=== 12){
                    // alert(this.date);
                    this.date= 31;
                }
                else if(value=== 2) {
                    if(date%4 === 0) {
                        this.date= 29;
                    }
                    else {
                        this.date= 28;
                    }
                }
                else {
                    this.date= 30;
                }
            },
        },
        mounted() { 
            if(this.$route.params.courseCode){
                Service.fetchSingleCourse(this.$route.params.courseCode)
                .then((res)=> {
                    this.courseData= res.data.data;
                })
                .catch((err)=> console.log(err))
            }
            else {
                console.log('No course code founded')
            }
            let date= new Date().getFullYear();
            let beginYear= date-60;
            //1960
            for(let i = beginYear;i<=date;i++){
                this.year.push(i)
            }
        }
    } 
</script>

<style scoped>
.container {
    padding-top: 120px;
}
</style>